import { VgEmploymentState } from '@interfaces/models/open-account-mfes/employment-mfe.model';
import { createSelector } from '@ngrx/store';

import * as fromFeature from '../../reducers/index';
import * as fromOpenAccount from '../../reducers/open-account/open-account.reducer';

export const selectOpenAccountState = createSelector(
  fromFeature.getOpenAccountState,
  (state) => state,
);

export const selectOpenAccountResponse = createSelector(
  selectOpenAccountState,
  fromOpenAccount.getOpenAccountResponse,
);

export const selectSubmitMetricsID = createSelector(
  selectOpenAccountState,
  fromOpenAccount.getSubmitMetricsID,
);

export const selectSettlementFundChoice = createSelector(
  selectOpenAccountState,
  fromOpenAccount.getSettlementFundChoice,
);

export const selectIsEditingProfile = createSelector(
  selectOpenAccountState,
  fromOpenAccount.getIsEditingProfile,
);

export const selectIsEditingEmployment = createSelector(
  selectOpenAccountState,
  fromOpenAccount.getIsEditingEmployment,
);

export const selectIsEditingAccount = createSelector(
  selectOpenAccountState,
  fromOpenAccount.getIsEditingAccount,
);

// Employment MFE selectors

export const selectEmploymentMfeData = createSelector(
  selectOpenAccountState,
  fromOpenAccount.getEmploymentMfeData,
);

export const selectEmploymentMfeValidationStatus = createSelector(
  selectOpenAccountState,
  fromOpenAccount.getEmploymentMfeValidationStatus,
);

export const selectEmploymentMfeDataByOwnerIndex = (ownerIndex: number) =>
  createSelector(
    selectEmploymentMfeData,
    (employmentData): Partial<VgEmploymentState> | undefined => employmentData?.[ownerIndex],
  );
